<template>
    <div class="bar-chart-component">
        <apexchart
                :options="chartOptions"
                :series="barData"
                :height="barHeight"
        />
    </div>
</template>

<script>
    
    export default {
        name: "BarChart",
        props: {
            barData: {
                type: Array,
                required: true
            },
            barHeight: {
                type: Number,
                default: 200
            },
            chartOptions: {
                type: Object,
                default() {
                    return this.options;
                }
            }
        },
        data() {
            return {
                options: {
                    chart: {
                        type: 'bar',
                        id: 'bar-' + this.makeId(),
                        toolbar: {
                            show: false
                        }
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                position: 'top', // top, center, bottom
                            },
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        offsetY: -8,
                        style: {
                            fontSize: '13px',
                            colors: ["#304758"],
                        }
                    },
                    yaxis: {
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false,
                        },
                        labels: {
                            show: false,
                        }
                        
                    },
                }
            }
        }
    }
</script>

<style scoped>

</style>
